import { render, staticRenderFns } from "./ImportMenus.vue?vue&type=template&id=4494bc04"
import script from "./ImportMenus.vue?vue&type=script&lang=ts"
export * from "./ImportMenus.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports